import * as React from "react";

import { cn } from "@sunfish/lib/utils";

// Shared with Card's `tan` variant so the two structural shapes (bare tile vs.
// header/content composition) can't drift on color independently.
export const tanSurfaceClassName = "border-cream-300 bg-cream-50 dark:border-border dark:bg-card";

const TanCard = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("rounded-xl border p-4", tanSurfaceClassName, className)} {...props} />
  ),
);
TanCard.displayName = "TanCard";

export { TanCard };
